import {
  getMultiStepQuizTemplate,
  getMultiStepQuizWithLoaderTemplate,
  getVueMultiStepQuiz,
  getVueMultiStepQuizWithLoader,
} from "../../shortcodes/templates";

let multiStepQuiz = null;
const visualizeMultiStepQuiz = content => {
  multiStepQuiz = content.querySelectorAll('[data-tiny-mce-component="multistepquiz"]');
  if (multiStepQuiz.length > 0) {
    multiStepQuiz.forEach(item => {
      if (item.classList.contains("quiz-with-loader")) {
        const quizData = item.getAttribute("data-multi-step-quiz-data");
        item.outerHTML = getMultiStepQuizWithLoaderTemplate(quizData);
      } else {
        const quizData = item.getAttribute("data-multi-step-quiz-data");
        item.outerHTML = getMultiStepQuizTemplate(quizData);
      }
    });
  }
};

const serializeMultiStepQuiz = content => {
  const multiStepQuizWidget = content.querySelectorAll('[data-tiny-mce-component="multistepquiz"]');
  if (multiStepQuizWidget.length > 0) {
    multiStepQuizWidget.forEach(item => {
      if (item.classList.contains("quiz-with-loader")) {
        const quizData = item.getAttribute("data-multi-step-quiz-data");
        item.innerHTML = getVueMultiStepQuizWithLoader(quizData);
      } else {
        const quizData = item.getAttribute("data-multi-step-quiz-data");
        item.innerHTML = getVueMultiStepQuiz(quizData);
      }
    });
  }
};

export { visualizeMultiStepQuiz, serializeMultiStepQuiz };
